import { useEffect, useState } from "react";
import axiosInstance from "../../connections/axiosInstance";
import { DateFormat } from "../../services/dateFormat";
import { useNavigate } from "react-router-dom";

export default function Invoice() {
    const [invoices, setInvoices] = useState(() => {
        const sessionInvoices = sessionStorage.getItem("invoices");
        return sessionInvoices ? JSON.parse(sessionInvoices) : [];
    });
    const navigate = useNavigate()
    
    useEffect(() => {
        const fetchInvoices = async () => {
            // fetch invoice
            const { data } = await axiosInstance.get("/invoice");
            const invoicesData = data.result?.map((invoice) => {
                // update date and total
                const total = invoice.currency === "JPY" ? invoice.total * invoice.rate : invoice.total;
                return {
                    ...invoice,
                    total_idr: Intl.NumberFormat().format(total),
                    createAT: new DateFormat(new Date(invoice.createAT).getTime()).display(),
                };
            });
            setInvoices(invoicesData);
            sessionStorage.setItem("invoices", JSON.stringify(invoicesData));
        };

        fetchInvoices();
    }, []);

    return (
        <main className="px-3 w-full">
            <h1>INVOICE</h1>
            <section>
                <button className="text-blue-600 underline" onClick={() => navigate("/invoice-create")}>Create New Invoice</button>
            </section>
            <section className="rounded-xl overflow-hidden border-2 md:w-3/4 my-5 hidden">
                <table className="w-full capitalize bg-white overflow-scroll">
                    <thead className="">
                        <tr>
                            <td className="w-12">No</td>
                            <td>Date</td>
                            <td>Name</td>
                            <td>Amount</td>
                            <td>Action</td>
                        </tr>
                    </thead>
                    <tbody className="">
                        {invoices?.map((invoice, index) => (
                            <tr key={index} className="border-b py-2">
                                <td className="w-12">{index + 1}</td>
                                <td>{invoice.createAT}</td>
                                <td>{invoice.name}</td>
                                <td>Rp {invoice.total_idr}</td>
                                <td>
                                    <button
                                        className="text-[var(--blue)] underline"
                                        onClick={() => navigate(`/invoice/${invoice._id}`, { state: invoice })}
                                    >
                                        see more
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>
        </main>
    );
}
